// Cores livres usadas nesta sessão, compartilhadas entre todos os ColorField.
import { ref } from 'vue';

export const recentColors = ref([]);
